import classnames from 'classnames'
import * as React from 'react'

import { StyleBreakpoints } from '@/lib/StyleVariables.ts'
import { useWindowSize } from '@/lib/useWindowSize.ts'

import { UTMLink, type UTMLinkProps } from '../UTMLink/UTMLink.tsx'
import styles from './NordicButton.module.scss'

interface NordicLinkProps extends UTMLinkProps {
	centered?: boolean
	className?: string
	marginBottom?: boolean
	marginLeft?: boolean
	marginRight?: boolean
	marginTop?: boolean
	showSlant?: boolean
	size?: 'small' | 'large'
	mobileIcon?:
		| 'delete_forever'
		| 'refresh'
		| 'edit'
		| 'drive_file_rename_outline'
		| 'add_photo_alternate'
		| string
	variant?: string
}

const NordicLink: React.FC<NordicLinkProps> = ({
	children,
	centered,
	className,
	size,
	marginBottom,
	marginLeft,
	marginRight,
	marginTop,
	showSlant,
	variant = 'primary',
	mobileIcon,
	preserveUtmParams,
	utmParams,
	...props
}) => {
	const { width } = useWindowSize()

	const isSiteIcon = mobileIcon?.includes('site-icon')

	return (
		<UTMLink
			className={classnames(
				styles.button,
				styles[variant as keyof typeof styles],
				styles[size as keyof typeof styles],
				centered && styles.centered,
				marginBottom && styles.marginBottom,
				marginLeft && styles.marginLeft,
				marginRight && styles.marginRight,
				marginTop && styles.marginTop,
				showSlant ? styles.slant : styles.noSlant,
				className,
			)}
			preserveUtmParams={preserveUtmParams}
			utmParams={utmParams}
			{...props}
		>
			{mobileIcon && width <= StyleBreakpoints.sm ? (
				<i
					className={
						isSiteIcon
							? `${mobileIcon} ${styles.siteIcon}`
							: 'material-icons icon-no-margin'
					}
				>
					{!isSiteIcon && mobileIcon}
				</i>
			) : (
				children
			)}
		</UTMLink>
	)
}

export default NordicLink
